import { createContext } from 'react';
import type { AuthorizationContextType } from './AuthorizationTypes';

const AuthorizationContext = createContext<AuthorizationContextType | null>(null);

export default AuthorizationContext;